import colormap from 'colormap';
import GeoJSON from 'ol/format/GeoJSON.js';
import GeoTIFF from 'ol/source/GeoTIFF.js';
import TileLayer from 'ol/layer/WebGLTile.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import HeatmapLayer from 'ol/layer/Heatmap.js';
import BingMaps from 'ol/source/BingMaps.js';

import {Circle, Fill, Stroke, Style} from 'ol/style.js';

import CircleStyle from 'ol/style/Circle.js';
import Text from 'ol/style/Text.js';

import {createRangeInputDual } from './uitools';
import { Cluster } from 'ol/source';
import { CheckBoxItem } from '../../data/CheckBoxItemLayers';


class ColormapDetails {


    constructor(params) {
        if (params === undefined) params = {}
        this.values = (params.values) ? params.values : [-10, 10];
        this.range = (params.range) ? params.range : [-10, 10];
        this.colormap = (params.colormap) ? params.colormap : 'jet';
        this.numShades = (params.numShades) ? params.numShades : 120;
        this.flipColors = (params.flipColors) ? params.flipColors :false;
        this.bandMath = (params.bandMath) ? params.bandMath : ['band', 1];
        this.shift = (params.shift) ? params.shift : 0;
        this.scale = (params.scale) ? params.scale : 1;
        this.voidBelowMin = (params.voidBelowMin) ? params.voidBelowMin : false;
        this.voidAboveMax = (params.voidAboveMax) ? params.voidAboveMax : false;
        this.voidBetweenMinMax = (params.voidBetweenMinMax) ? params.voidBetweenMinMax : false;
        this.processViewingArea = (params.processViewingArea) ? params.processViewingArea : false;
        this.opacity = (params.opacity) ? params.opacity : 1.0;
    }

    getStyle(numLayers) {
        return getColormapStyle(
            numLayers,
            this.colormap, this.values[0],
            this.values[1], this.numShades,
            this.flipColors, this.bandMath,
            this.voidBelowMin, this.voidAboveMax, this.voidBetweenMinMax
        );
    }

    createColormapDetailsElements(imageLayer)
    {
        function createCheckBox(item, dataName, text) {
            const checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.checked = item[dataName];
            checkbox.addEventListener('change', (e) => {
                item[dataName] = e.currentTarget.checked;
                imageLayer.updateLayerStyle();
            });
            const label = document.createElement('label');
            label.innerText = text;
            label.appendChild(checkbox);
            return label;
        }

        const settingDiv = document.createElement('div');

        const header = document.createElement('h5');
        header.innerHTML = 'Image Controls';
        settingDiv.appendChild(header);

        const rangeInput = createRangeInputDual(this, 'Adjust Colormap', imageLayer);

        const formElements = [rangeInput];

        const scale = document.createElement('input');
        scale.value = this.scale;
        scale.addEventListener('change', (e) => {
            this.scale = parseFloat(e.currentTarget.value);
            imageLayer.updateLayerStyle();
        });
        const scaleLabel = document.createElement('label');
        scaleLabel.innerText = 'Scale value: ';
        scaleLabel.appendChild(scale);

        formElements.push(scaleLabel);

        const shift = document.createElement('input');
        shift.value = this.shift;
        shift.addEventListener('change', (e) => {
            this.shift = parseFloat(e.currentTarget.value);
            imageLayer.updateLayerStyle();
        });
        const shiftLabel = document.createElement('label');
        shiftLabel.innerText = 'Shift value: ';
        shiftLabel.appendChild(shift);

        formElements.push(shiftLabel);

        formElements.push(
            createCheckBox(this, 'voidBelowMin', 'Void Below Minimum: '));
        formElements.push(
            createCheckBox(this, 'voidAboveMax', 'Void Above Maximum: '));
        formElements.push(
            createCheckBox(this, 'voidBetweenMinMax', 'Void Between Min/Max: '));

        const opacity = document.createElement('input');
        opacity.value = this.opacity;
        opacity.addEventListener('change', (e) => {
            this.opacity = parseFloat(e.currentTarget.value);
            imageLayer.layer.setOpacity(this.opacity);
        });
        const OpacityLabel = document.createElement('label');
        OpacityLabel.innerText = 'Layer Transparency: ';
        OpacityLabel.appendChild(opacity);

        formElements.push(OpacityLabel);


        const ul = document.createElement('ul');
        ul.className = 'checkBox_li';
        formElements.forEach((e) => {
            const li = document.createElement('li');
            li.classList.add('form-row');
            li.appendChild(e);
            ul.appendChild(li);
        });
        settingDiv.appendChild(ul);      
        return settingDiv;  
    }
    
}

class ImageLayer {
    layer = null;
    source = null;
    activeLayers = null;
    numLayers = 0;

    constructor(params) {
        this.colormapDetails = params.colormapDetails;

        this.name = (params.name) ? params.name : 'unnammed';
        if (params.urls && params.inputLayers) {
            throw new Error("Pass array of urls or an array of ImageLayers")
        }
        if (params.urls) {
            this.urls = params.urls;
            this.numLayers = params.urls.length;
            this.setUpSource();
        }
    }

    updateBandMath() {
        this.colormapDetails.bandMath = ['+', ['*', ['band', 1], this.colormapDetails.scale], this.colormapDetails.shift];
    }

    updateLayerStyle() {
        this.updateBandMath();
        if (this.layer != null) {
            this.layer.setStyle(this.colormapDetails.getStyle(this.numLayers));
        }
    }
    update() {
        this.updateLayerStyle();
    }

    setUpSource() {
        const sources = this.urls.map((url) => ({ url: url }));
        this.source = new GeoTIFF({
            normalize: false,
            sources: sources
        });
    }

    addLayer()
    {
        this.layer = new TileLayer({
            source: this.source,
            name: this.name,
            layerType: 'imageLayer',
        });
        this.updateLayerStyle();
        this.layer.setOpacity(this.colormapDetails.opacity)
        window.map.layerManager.addLayer(this.layer);

    }

    removeLayer() 
    {
        window.map.layerManager.removeLayer(this.layer.get('name'))
        this.layer = null;
    }

}

class ElevationImageLayer extends ImageLayer 
{
    constructor(params) 
    {
        super(params);
        this.bandMath = ['+', ['*', ['band', 1], this.scale], this.shift];
    }
}

class ElevationHillshadeLayer extends ImageLayer
{
    constructor(params)
    {
        super(params);

    }
}

class MagImageLayer extends ImageLayer {

    constructor(params) {
        super(params);
        //this.bandMath = ['+', ['*', ['band', 1], this.scale], this.shift];
    }
}

class DiffImageLayer extends ImageLayer {
    constructor(params) {
        super(params);
        this.srcColormapDetails = params.srcColormapDetails;
        this.updateBandMath();
        //        this.colormapDetails.bandMath = ['-', ['band', 2], ['band', 1]];
    }

    updateBandMath() {
        const band2 = ['+', ['*', ['band', 2], this.srcColormapDetails[1].scale], this.srcColormapDetails[1].shift];
        const band1 = ['+', ['*', ['band', 1], this.srcColormapDetails[0].scale], this.srcColormapDetails[0].shift];
        this.colormapDetails.bandMath =
        ['+', ['*', ['-', band2, band1], this.colormapDetails.scale], this.colormapDetails.shift];
    }
}

class ShaderImageLayer extends ImageLayer {

    constructor(params) {
        super(params);
        this.colormapDetails.values = [0, 255];
        this.colormapDetails.range = [0, 255];
        this.colormapDetails.colormap = 'greys';
        this.bandMath = ['+', ['*', ['band', 1], this.scale], this.shift];
    }
}

class RGBLayer extends ImageLayer {
    constructor(params) {
        super(params);
        this.colormapDetails.values = [0, 255];
        this.colormapDetails.range = [0, 255];
//        this.updateBandMath();
        this.bandMath = [];
        for (let i = 1; i <= 3; i++) {
            this.bandMath.push(['+', ['*', ['band', i], this.colormapDetails.scale], this.colormapDetails.shift]);
        }
}


    updateBandMath() {
        this.bandMath = [];
        for (let i = 1; i <= 3; i++) {
            this.bandMath.push(['+', ['*', ['band', i], this.colormapDetails.scale], this.colormapDetails.shift]);
        }
    }

    updateLayerStyle() {
        return;
//         this.updateBandMath();
//         if (this.layer != null) {
//             this.layer.setStyle({
//                 color: ['array', this.bandMath[0], this.bandMath[1], this.bandMath[2], this.colormapDetails.opacity],
// //                gamma: 1.1,
//             });
//         //    this.layer.setStyle({
//         //        color: ['array', ['band', 1], ['band', 2], ['band', 3], 1],
//         //        gamma: 1.1,
//         //    });
//         }
    }


}


class RGBDiffLayer extends RGBLayer {
    constructor(layerName, urls, inputLayers, parent) {
        super(layerName, urls, parent);
        this.inputLayers = inputLayers;
        this.colormapDetails.values = [-20, 20];
        this.colormapDetails.range = [-255, 255];
//        this.updateBandMath();

    }

    updateBandMath() {
        this.bandMath = [];
        for (let i = 1; i <= 3; i++) {
            const color1 = ['*', ['+', ['band', i], this.inputLayers[0].colormapDetails.shift], this.inputLayers[0].colormapDetails.scale];
            const color2 = ['*', ['+', ['band', i + 3], this.inputLayers[1].colormapDetails.shift], this.inputLayers[1].colormapDetails.scale];
            const diff = ['-', color2, color1];
            this.bandMath.push( ['+', ['*', diff, this.colormapDetails.scale], this.colormapDetails.shift] );            
        }
    }
    setUpSource(args) {
        const sources = args.map((url) => ({ url: url }));
        this.source = new GeoTIFF({
            sources: sources
        });
    }

}


function getColormapStyle(numLayers, colormapName, min, max, numSteps, flipColors, bandMath = ['band', 1], voidBelowMin, voidAboveMax, voidBetweenMinMax, transparentBelow = -30000) {
    if (min <= transparentBelow) {
        throw new Error("Range min is too low");
    }
    function getColorStops() {
        const delta = (max - min) / (numSteps - 1);
        const colors = colormap({ colormap: colormapName, nshades: numSteps, format: 'rgba' });
        if (flipColors) {
            colors.reverse();
        }
        if (voidBelowMin) { colors[0][3] = 0; }
        if (voidAboveMax) { colors[colors.length - 1][3] = 0; }
        if (voidBetweenMinMax) {
            for (let i = 1; i < colors.length - 1; i++) {
                colors[i][3] = 0;
            }
        }
        const stops = new Array((numSteps + 2) * 2);
        stops[0] = -3200000;
        stops[1] = [0, 0, 0, 0];
        stops[2] = transparentBelow;
        stops[3] = [0, 0, 0, 0];
        for (let i = 0; i < numSteps; i++) {
            stops[(i + 2) * 2] = min + i * delta;
            stops[(i + 2) * 2 + 1] = colors[i];
        }
        return stops;
    }
    return {
        color: [
            'case',
            ['>', ['band', numLayers + 1], 0],
            [
                'interpolate',
                ['linear'],
                bandMath,
                ...getColorStops(),
            ],
            [0,0,0,0],
        ],
    }
    // return {
    //     color: [
    //         'interpolate',
    //         ['linear'],
    //         bandMath,
    //         ...getColorStops(),
    //     ],
    // }
}

class GeoJsonLayer {
    layer = null;
    source = null;
    activeLayers = null;

    constructor(params) {

        this.name = (params.name) ? params.name : 'unnammed';
        if (!params.url) { throw new Error("Pass the url from the GeoJson file")}
        else {
            this.url = params.url;
            this.setUpSource();
        }
    }


    updateLayerStyle() {
        return false;
        // this.updateBandMath();
        // if (this.layer != null) {
        //     this.layer.setStyle(this.colormapDetails.getStyle(this.numLayers));
        // }
    }
    update() {
        this.updateLayerStyle();
    }

    setUpSource() {
        this.source = new VectorSource({
            format: new GeoJSON(),
            url: this.url,
        });
    }

    addLayer()
    {
        this.layer = new VectorLayer({
            source: this.source,
            name: this.name,
            layerType: 'vectorLayer'
        });
        this.updateLayerStyle();
        this.layer.setOpacity(1)
        window.map.layerManager.addLayer(this.layer);

    }

    removeLayer() 
    {
        window.map.layerManager.removeLayer(this.layer.get('name'))
        this.layer = null;
    }

    getStyle(fillColor)
    {
        const simpleStyle = new Style({
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0.6)',
            }),
            stroke: new Stroke({
              color: '#319FD3',
              width: 1,
            }),
          });
        return simpleStyle;

    }

}

class GeoJsonHeatMapLayer {
    layer = null;
    source = null;
    activeLayers = null;

    constructor(params) {

        this.name = (params.name) ? params.name : 'unnammed';
        if (!params.url) { throw new Error("Pass the url from the GeoJson file")}
        else {
            this.url = params.url;
            this.setUpSource();
        }
    }


    updateLayerStyle() {
        return false;
        // this.updateBandMath();
        // if (this.layer != null) {
        //     this.layer.setStyle(this.colormapDetails.getStyle(this.numLayers));
        // }
    }
    update() {
        this.updateLayerStyle();
    }

    setUpSource() {
        this.source = new VectorSource({
            format: new GeoJSON(),
            url: this.url,
        });
    }

    addLayer()
    {
        this.layer = new HeatmapLayer({
            source: this.source,
            name: this.name,
            layerType: 'vectorLayer'
        });
        this.updateLayerStyle();
        this.layer.setOpacity(1)
        window.map.layerManager.addLayer(this.layer);

    }

    removeLayer() 
    {
        window.map.layerManager.removeLayer(this.layer.get('name'))
        this.layer = null;
    }

}

class GeoJsonClusterLayer extends GeoJsonLayer{

    rawSource = null;
    rawLayer = null;
    constructor(params) {
        super(params);
        this.fillColor = (params.fillColor) ? params.fillColor : 'rgba(0, 175, 181, 0.5)';
    }


    updateLayerStyle() {
        return false;
        // this.updateBandMath();
        // if (this.layer != null) {
        //     this.layer.setStyle(this.colormapDetails.getStyle(this.numLayers));
        // }
    }
    update() {
        this.updateLayerStyle();
    }

    setUpSource() {
        function getPoint(feature) { 
            const geometry = feature.getGeometry();
            switch(geometry.getType())
            {
                case 'Point':
                    return geometry;
                case 'Polygon':
                    return geometry.getInteriorPoint();
                case 'MultiPolygon':
                    return geometry.getInteriorPoints().getPoint(0);
                default:
                    throw new Error('Unsupported type: ' + geometry.getType());
            }
        }
        const rawSource= new VectorSource({
            format: new GeoJSON(),
            url: this.url,
        });

        this.source = new Cluster({
            format: new GeoJSON(),
            source: rawSource,
            distance: 100,
            minDistance: 50,
            geometryFunction: getPoint,
        });
    }

    addLayer()
    {
        const styleCache = {};
        const fillColor =  this.fillColor;
        this.layer = new VectorLayer({
            source: this.source,
            name: this.name,
            layerType: 'vectorLayer',
            minZoom: 1,
            maxZoom: 15,
            style: function (feature) {
                const size = feature.get('features').length;
                let style = styleCache[size];
                if (!style) {
                  style = new Style({
                    image: new CircleStyle({
                      radius: 15,
                      stroke: new Stroke({
                        color: '#fff',
                      }),
                      fill: new Fill({ color: fillColor, }),
                    }),
                    text: new Text({
                      text: size.toString(),
                      fill: new Fill({ color: '#fff', }),
                    }),
                  });
                  styleCache[size] = style;
                }
                return style;
            },            
        });
        this.updateLayerStyle();
        this.layer.setOpacity(1)
        window.map.layerManager.addLayer(this.layer);

        this.rawLayer = new VectorLayer(
        {
            source: new VectorSource({
                format: new GeoJSON(),
                url: this.url,
            }),
            name: this.name + '-2',
            layerType: 'vectorLayer',
            minZoom: 15,
            maxZoom: 30,
            style:  new Style({
                    image: new CircleStyle({
                      radius: 5,
                      stroke: new Stroke({
                        color: '#fff',
                      }),
                      fill: new Fill({ color: fillColor, }),
                    }),
                    fill: new Fill({ color: fillColor, }),
                }),            
 
        });
        this.rawLayer.setOpacity(1)
        window.map.layerManager.addLayer(this.rawLayer);

    }

    removeLayer() 
    {
        window.map.layerManager.removeLayer(this.layer.get('name'));
        window.map.layerManager.removeLayer(this.rawLayer.get('name'))
        this.layer = null;
        this.rawLayer = null;
    }
}

class BingMapsLayer
{
    constructor(params) {
        this.name = (params.name) ? params.name : 'unnammed';
    }    

    addLayer()
    {
        this.layer = new TileLayer({
            preload: Infinity,
            source: new BingMaps({
                key: 'AqBjue5S0MnMj-kuOfr0xrddeY1KuV1Fo4a9bLl3eggNf0sRBoN0sh4ZZMCCJE-N',
                imagerySet: 'AerialWithLabelsOnDemand',
                placeholderTiles: false, // Optional. Prevents showing of BingMaps placeholder tiles
            }),
            name: this.name,                
            layerType: 'imageLayer'
        });
        // this.updateLayerStyle();
        // this.layer.setOpacity(this.colormapDetails.opacity)
        window.map.layerManager.addLayer(this.layer);

    }

    removeLayer() 
    {
        window.map.layerManager.removeLayer(this.layer.get('name'))
        this.layer = null;
    }
}

export { ColormapDetails, ElevationImageLayer, MagImageLayer, ShaderImageLayer, DiffImageLayer, RGBLayer, RGBDiffLayer, GeoJsonLayer, GeoJsonHeatMapLayer, GeoJsonClusterLayer, BingMapsLayer };

